function isValidUrl(value: string) {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

function isValidDataImageUrl(value: string) {
  // Must be a string starting with data:image/<type>;base64,<payload>
  const match = /^data:image\/([a-zA-Z0-9.+-]+);base64,([A-Za-z0-9+/]+={0,2})$/.exec(value);
  if (!match) return false;

  const [, subtype, payload] = match;

  // Optional: restrict allowed image subtypes
  const allowed = ['png', 'jpeg', 'jpg', 'gif', 'webp', 'svg+xml', 'bmp', 'avif'];
  if (!subtype || !allowed.includes(subtype.toLowerCase())) return false;

  // Payload length must be a multiple of 4 (base64 rule)
  if (!payload || payload.length % 4 !== 0) return false;

  // decode and sanity-check it's actually an image
  try {
    const bytes = atob(payload);
    if (bytes.length === 0) return false;
    return isImageSignature(bytes, subtype.toLowerCase());
  } catch {
    return false;
  }
}

function isImageSignature(bytes: string, subtype: string) {
  const b = (i: number) => bytes.charCodeAt(i);
  switch (subtype) {
    case 'png':
      return b(0) === 0x89 && bytes.slice(1, 4) === 'PNG';
    case 'jpeg':
    case 'jpg':
      return b(0) === 0xff && b(1) === 0xd8;
    case 'gif':
      return bytes.slice(0, 3) === 'GIF';
    case 'webp':
      return bytes.slice(0, 4) === 'RIFF' && bytes.slice(8, 12) === 'WEBP';
    case 'bmp':
      return bytes.slice(0, 2) === 'BM';
    case 'avif':
      return bytes.slice(4, 8) === 'ftyp';
    case 'svg+xml':
      // SVG is text; check for an <svg ...> tag
      return /<svg[\s>]/i.test(bytes);
    default:
      return true;
  }
}

export const Validators = {
  isValidUrl,
  isValidDataImageUrl,
};
